(function() {
    angular
        .module('emarket.main.profile')
        .controller('BuyDialogController', ['$log', '$scope', '$mdDialog', '$mdToast', 'Profile', 'Auth', 'Transaction', 'Announcer', 'plans', 'plan', function($log,
            $scope,
            $mdDialog,
            $mdToast,
            Profile,
            Auth,
            Transaction,
            Announcer,
            plans,
            plan) {
            var announcer = Announcer.create($scope);
            var vm = this;
            vm.plans = plans;
            vm.user = Auth.getUser();
            vm.shop = {
                days: 30,
                plan: plan
            };

            vm.calculateDailyPlan = function(currentPlan) {
                vm.cost = currentPlan.price / 30 * vm.shop.days;
                if (vm.cost > vm.user.balance) {
                    vm.invalid = true;
                } else {
                    vm.invalid = false;
                }
            };
            vm.calculateDailyPlan(plan);
            vm.close = function(resolve) {
                $mdDialog.hide(resolve);
            };
            vm.searchUser = function(username) {
                Profile.$search({ username: username })
                    .$asPromise()
                    .then(function(response) {
                        var user = response[0];
                        if (user) {
                            vm.userFound = user;
                        } else {
                            vm.userFound = null;
                        }
                    });
            };
            vm.onSubmit = function() {
                var params = {
                    days: vm.shop.days,
                    plan: vm.shop.plan._id
                };
                if (vm.userFound) {
                    params.applyTo = vm.userFound._id;
                }
                Transaction.buyPlan(params).then(function() {
                    Profile.$find(vm.user._id)
                        .$asPromise()
                        .then(function(user) {
                            Auth.setUser(user);
                            announcer.emit(Auth.USER_CHANGE);
                            vm.close();
                            $mdToast.show($mdToast.simple().textContent('Agregado exitosamente'));
                        });
                });
            };
        }]);
}());
